module.exports = __webpack_public_path__ + "img/left.452d2422.png";